import classNames from 'classnames';
import { TemplateClassNames } from '../../../../types/template-layouts';
import { HomepageFooter, LanguagesAbbr } from '../../../../types/working-model';

// temporarily hardcoded logos
import LogoBrandlive from '../../../../images/BrandLive_Logo.svg';
import LogoBrandliveLight from '../../../../images/BrandLive_Logo_light.svg';
import './footer.scss';
import React from 'react';
import NavItem from '../../../admin/create/homepage/editor/header/nav-item';
import { getHeaderStylingOverrides } from '../../utils';
// import { useTranslation } from 'react-i18next';

interface FooterProps {
	footer: HomepageFooter;
	template: TemplateClassNames;
	previewLanguage?: LanguagesAbbr
}

const Footer: React.FC<FooterProps> = ({ footer, template, previewLanguage }) => {
	const { logo } = footer;
	const {
		backgroundColor,
		backgroundImg,
		mainTextOverrides
	} = getHeaderStylingOverrides(footer.styling_overrides);
	// const { t } = useTranslation("homepage");

	const renderLinks = () => {
		// TODO: marketing page needs to pass header a handleScroll function
		// reference editor-main.tsx for functionality

		// TODO: implement ref forwarding for each module rendered on page
		const overrideColor = mainTextOverrides?.split('-')[0];
		const navItems = footer.navItems?.map((navItem, i) => (
			<NavItem
				key={navItem.button_name.base + i}
				navItem={navItem}
				handleScroll={() => ({})}
				className={classNames(
					"footer-nav-item",
					mainTextOverrides,
					{ [`${overrideColor}-hover`]: mainTextOverrides }
				)}
				previewLanguage={previewLanguage}
			/>
		));
		return navItems;
	};

	return (
		<footer className={classNames("marketing-page-footer", template, backgroundColor)}>
			<div className={classNames("footer-container")} style={backgroundImg}>
				<div className="footer-left">
					<img className="footer-logo" src={logo ? logo : ''} aria-hidden="true" alt="" />
				</div>
				<nav className="footer-nav">
					{/*TODO:  change these to link anchors in the marketing page and will be dynamic*/}
					{renderLinks()}
				</nav>
				<div className="footer-right">
					<div className="footer-author">
						<div className="footer-author-text">POWERED BY</div>
						<img src={template === TemplateClassNames['Studio 54'] ? LogoBrandliveLight : LogoBrandlive} aria-hidden="true" alt="powered by Brandlive" />
					</div>
				</div>
				{/* remove copyright pending further discussions - keep div for formating */}
				<div className="footer-copyright">
					{/* &copy; {new Date().getFullYear()}. {t("footer.Copyright")} Brandlive.com */}
				</div>
			</div>
		</footer>
	);
};

export default Footer;
